<template>
    <div class="answers-list">
        <div class="col-nav">
            <ul>
                <li v-for="item in listData.list" :class="{active : item.category == questListActiveLink}" @click="filterItems(item.category)"><span>{{ item.category }}</span></li>
            </ul>
        </div>
        <div class="col-info">
            <div class="answer-list-items" id="accordion" aria-multiselectable="true">
                <div class="panel" v-for="(panel, index) in questListActive" :key="index">
                    <div class="panel-title">
                        <a :href="'#collapsePanelItem' + index" class="panel-link" data-parent="#accordion" data-toggle="collapse" :aria-expanded="[index === 0 ? true : false]">
                            <span>{{panel.q_name}}</span>
                            <div class="btn-press">
                                <span class="plus">+</span>
                                <span class="minus">-</span>
                            </div>
                        </a>
                    </div>
                    <div :id="'collapsePanelItem' + index" class="panel-collapse collapse" :class="{ 'in': index === 0 }">
                        <div class="items-list">
                            <div class="item"><div class="desc-html" v-html="panel.q_desc"></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'answers-list',
        props: ['listData'],
        components: {
            // svgIcon,
        },
        data () {
            return {
                questListActive: null,
                questListActiveLink: null,
            }
        },
        computed: mapGetters({
            questionsPage: 'loadQuestionsPage',
        }),
        methods: {
            filterItems(category) {
                this.questListActiveLink = category;
                var arr = this.listData.list;
                var filterItems = arr.filter(function( obj ) {
                    return obj.category == category;
                }); 
                this.questListActive = filterItems[0].q_answers;
                console.log(this.questListActive, 'asdasdasdasd')
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.filterItems(this.listData.list[0].category);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/answers-page/answers-list.scss';
    @import '@/styles/components/answers-page/respond/answers-list-respond.scss';
</style>